import React, {useEffect, Fragment} from "react";
import {connect} from "react-redux";

import WizardPopupEntitiesExclusionTopFilters from "../WizardPopupFeaturesExclusion/WizardPopupEntitiesExclusionTopFilters";
import {FormattedMessage} from "react-intl";
import WizardPopupContext, {useCustomContext} from "../WizardPopupContext";
import {
  getAllFilterGroups,
  getFilterValuesByGroup
} from "../../../FeatureCreator/FeaturesFilters/FeaturesFiltersActions";
import WizardPopupFiltersExclusionFilter from "./WizardPopupFiltersExclusionFilter";

const WizardPopupFiltersExclusion = (props) => {

  const {wizardPopupGroup, allFilterGroups, filtersReceived} = props;

  const {wizardPopupState} = useCustomContext(WizardPopupContext);
  const {searchText} = wizardPopupState;

  const getFilters = async () => {
    if (!allFilterGroups.length) {
      await getAllFilterGroups();
    }
    if (!filtersReceived[wizardPopupGroup.groupName]) {
      //todo
      // await getFilterValuesByGroup(wizardPopupGroup.groupName)
    }
  }

  useEffect(() => {
    getFilters()
  }, []);

  if (!allFilterGroups.length) {
    return <div className="ui-loader"/>
  }

  const filterGroup = allFilterGroups.find(filterGroup => filterGroup.id === wizardPopupGroup.filterGroupId);

  if (!wizardPopupGroup.filterGroupId || !filterGroup) {
    return (
      <div className="fc-filters__empty">
        <FormattedMessage id="wizard.popup.noFilterGroupId"/>
      </div>
    )
  }

  console.log("filterGroup", filterGroup);

  if (!filterGroup.values || !filterGroup.values.length) {
    return (
      <div className="fc-filters__empty">
        <FormattedMessage id="wizard.popup.noFiltersFound" values={{groupName: wizardPopupGroup.groupName}}/>
      </div>
    )
  }

  let renderFilters = filterGroup.values;
  if (searchText) {
    const lowerCasedSearch = searchText.toLowerCase();
    renderFilters = renderFilters.filter(feature => (feature.displayText || feature.value || "").toLowerCase().includes(lowerCasedSearch))
  }

  return (
    <div className="wizard-popup">
      <WizardPopupEntitiesExclusionTopFilters renderFilters={renderFilters}/>
      {renderFilters.length ? (
        <div className="wizard-features">
          <ul className="wizard-features__list fix-ul">
            {renderFilters.map(filter => {
              return <WizardPopupFiltersExclusionFilter filter={filter} key={filter.id}/>
            })}
          </ul>
        </div>
      ) : (
        <div className="fc-filters__empty">
          <FormattedMessage id="wizard.popup.noFiltersFoundSearch"/>
        </div>
      )}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardPopupGroup} = store.wizardState;
  const {allFilterGroups, filtersReceived} = store.featuresFiltersState;

  return {
    wizardPopupGroup,
    allFilterGroups,
    filtersReceived
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(WizardPopupFiltersExclusion)
